import { Task } from 'redux-saga';
import { delay, fork } from 'redux-saga/effects';
import appSaga from './appSaga';
import backendSaga from './backend';
import backyardSaga from './backyard';
import surveySaga from './survey';

export default function* rootSaga() {
  yield fork(appSaga);
  yield fork(surveySaga);
  yield fork(backendSaga);
  yield fork(backyardSaga);
}

// 遅延実行
export function createLazily(msec = 1000) {
  let ongoing: Task | undefined;

  /* eslint-disable  @typescript-eslint/no-explicit-any, func-names */
  return function* (task: any, ...args: any[]) {
    if (ongoing && ongoing.isRunning()) {
      ongoing.cancel();
    }
    ongoing = yield fork(function* () {
      yield delay(msec);
      yield fork(task, ...args);
    });
  };
}

export interface CallEffectInterface<T> {
  payload?: T;
  error?: string;
  newXCSRFToken?: string;
}
